import React from 'react';

import { Button } from 'modules/cxi/components/button';
import { useCXI } from 'modules/cxi/useCXI';

import { Container } from '../container';
import * as Styled from './StyledEvaluateCheck';

export const EvaluateCheck = () => {
    const { t, modal, setModal } = useCXI();
    const { match } = modal;

    return (
        <Styled.EvaluateCheck as={Container.Slim}>
            <Container.Head image={match.startup.logoUrl} />

            <Container.Body>
                <Styled.Title>{t('modal.EvaluateCheck.title')}</Styled.Title>
                <Styled.Descr>{t('modal.EvaluateCheck.description')}</Styled.Descr>
            </Container.Body>

            <Container.Feet>
                <Button onClick={() => setModal(null)}>
                    <span className="text">{t('modal.EvaluateCheck.close')}</span>
                </Button>
                <Button variant="link" onClick={() => setModal({ match, modal: 'EvaluateForm' })}>
                    <span className="text">{t('modal.EvaluateCheck.continue')}</span>
                </Button>
            </Container.Feet>
        </Styled.EvaluateCheck>
    );
};
